import React from 'react';

import CoronaBanner from './TopBanner/Corona';

export const vendBannerForLocale = () => {
  // Use this function to vend locale specific banners
  // See file history for a previous example
  return () => <CoronaBanner />;
};
